import { Skeleton } from "@mui/material";

import { ReviewVisitTableCell } from "../../../../components/ReviewVisitTable";

export default function WeatherReportTableRowSkeleton() {
    return (
        <>
            <ReviewVisitTableCell>
                <Skeleton variant="text" width={120} />
            </ReviewVisitTableCell>
            <ReviewVisitTableCell>
                <Skeleton variant="text" width={60} />
            </ReviewVisitTableCell>
            <ReviewVisitTableCell>
                <Skeleton variant="text" width={60} />
            </ReviewVisitTableCell>
            <ReviewVisitTableCell>
                <Skeleton variant="circular" width={20} />
            </ReviewVisitTableCell>
        </>
    );
}
